import React from "react";
import {getSyncEngineVersion} from "../../../../common/helpers/syncEngine";
import InvoiceV1 from "../../LogV1/Invoice";
import InvoiceV2 from "../../LogV2/Invoice";

const Invoice: React.FC = () => {
    return getSyncEngineVersion() === 'v2' ? <InvoiceV2 /> : <InvoiceV1 />;
};

export default Invoice;
